/**
 * @description 转换价格为方便阅读的格式
 * @param {number}  num 需要转换的数字
 * @return {string} 返回格式化后的字符串
 * @memberof module:format
 * @example
 * imutils.formatShortSignUpNum(99999) // 9万
 * imutils.formatShortSignUpNum(999999) // 99万
 * imutils.formatShortSignUpNum(9999999) // 9百万
 * imutils.formatShortSignUpNum(99999999) // 9千万
 */
function formatShortSignUpNum(num) {
  if (num >= 1e7) {
    return "".concat(Math.floor(num / 1e7), "\u5343\u4E07");
  }

  if (num >= 1e6) {
    return "".concat(Math.floor(num / 1e6), "\u767E\u4E07");
  }

  if (num >= 1e4) {
    return "".concat(Math.floor(num / 1e4), "\u4E07");
  }

  return num;
}
/**
 * @description 日期格式化
 * @param {string} [pattern] - 日期格式 (格式化字符串的符号参考w3标准 http://www.w3.org/TR/NOTE-datetime)
 * @param {date|number} [date=new Date()] - 待格式化的日期对象或时间戳(毫秒)
 * @return {string} - 返回格式化后的日期字符串
 * @memberof module:format
 * @example
 * const now = new Date();
 * imutils.formatDate("YYYY-MM-DD hh:mm:ss", now); // 2018-08-24 16:00:00
 * imutils.formatDate("YYYY-MM-DD hh:mm:ss", 1568080923000); // 2019-09-10 10:02:03
 * imutils.formatDate("MM月DD日前完成", 1568080923000); // 2019-09-10 10:02:03
 */


function formatDate() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD hh:mm:ss';
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

  if (typeof date === 'number') {
    date = new Date(date);
  }

  function formatNumber(data, format) {
    // 3
    format = format.length;
    data = data || 0; // return format == 1 ? data : String(Math.pow(10,format)+data).substr(-format); // IE6有bug
    // return format == 1 ? data : (data=String(Math.pow(10,format)+data)).substr(data.length-format);

    return format === 1 ? data : String(Math.pow(10, format) + data).slice(-format);
  }

  return pattern.replace(/([YMDwhsmS])\1*/g, function (format) {
    switch (format.charAt(0)) {
      case 'Y':
        return formatNumber(date.getFullYear(), format);

      case 'M':
        return formatNumber(date.getMonth() + 1, format);

      case 'D':
        return formatNumber(date.getDate(), format);

      case 'w':
        return date.getDay() + 1;

      case 'h':
        return formatNumber(date.getHours(), format);

      case 'm':
        return formatNumber(date.getMinutes(), format);

      case 's':
        return formatNumber(date.getSeconds(), format);

      case 'S':
        return formatNumber(date.getMilliseconds(), format);

      default:
        break;
    }
  });
}
/**
 * @description 格式化任务的时间
 * @param {number} time - 时间戳，单位是秒
 * @param {string} [type] - 可选值有 short, middle或long;<br>
 *                        short返回时分;<br>
 *                        middle返回月日;<br>
 *                        long返回年月日时分
 * @return {string} 返回格式化后的字符串
 * @deprecated 请使用 formatDate
 */


function formatTaskTime(time) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'short';
  console.warn('imutils: formatTaskTime is deprecated please use imutils.formatDate directly');
  var date = new Date(time * 1000);
  var dateStr = '';
  var h = date.getHours();
  var m = date.getMinutes();
  h = h >= 10 ? h : "0".concat(h);
  m = m >= 10 ? m : "0".concat(m);

  if (type === 'short') {
    dateStr = "".concat(h, ":").concat(m);
  } else if (type === 'middle') {
    dateStr = "".concat(date.getMonth() + 1, "\u6708").concat(date.getDate(), "\u65E5 ").concat(h, ":").concat(m);
  } else {
    dateStr = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate(), " ").concat(h, ":").concat(m);
  }

  return dateStr;
}
/**
 * @description 数字左填充0
 * @param {number} padString - 待格式化的数字
 * @param {number} targetLength - 目标长度
 * @return {string} 返回填充后的字符串
 * @example
 * imutils.pad(7, 3); // return 007
 */


function pad(padString, targetLength) {
  padString = padString.toString();
  var i = padString.length;

  while (i++ < targetLength) {
    padString = "0".concat(padString);
  }

  return padString;
}
/**
 * @description 格式化时间戳
 * @param {number} time - 单位是 s
 * @return {string} 返回格式化字符串
 * @deprecated 请使用 formatDate
 */


function translateTimeStamp(time) {
  console.warn('imutils: translateTimeStamp is deprecated please use imutils.formatDate directly');
  var T = new Date(time * 1000);
  var y = T.getFullYear();
  var m = T.getMonth() + 1;
  var d = T.getDate();
  var h = T.getHours();
  var mm = T.getMinutes();
  var s = T.getSeconds();
  return "".concat(y, "-").concat(pad(m, 2), "-").concat(pad(d, 2), " ").concat(pad(h, 2), ":").concat(pad(mm, 2), ":").concat(pad(s, 2));
}

export { formatShortSignUpNum, formatDate, formatTaskTime, translateTimeStamp, pad };